import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchUserProfile } from '../api/userAPI';
import '../css/ProfilePage.css';
import defaultProfilePic from '../assets/image/defaultpic.jpeg';

function UserProfile({ username: propUsername }) {
  const { username: urlUsername } = useParams();
  const username = propUsername || urlUsername;
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUserProfile = async () => {
      setLoading(true);
      setError('');

      try {
        const profileData = await fetchUserProfile(username);
        setProfile(profileData.user);
      } catch (loadError) {
        setError(loadError.message || 'Unable to load this profile.');
      } finally {
        setLoading(false);
      }
    };

    if (username) {
      loadUserProfile();
    }
  }, [username]);

  if (loading) {
    return <div className="profile-page profile-state">Loading profile...</div>;
  }

  if (error) {
    return <div className="profile-page profile-state">{error}</div>;
  }

  return (
    <div className="profile-page">
      <div className="profile-page-header">
        <img src={profile.photoUrl || defaultProfilePic} alt="Profile" className="profile-avatar" />
        <div>
          <span className="profile-eyebrow">Contributor profile</span>
          <h1>{profile.fullName || profile.username}</h1>
          <p>
            Learn more about the person behind the interview reports and follow their public
            profile links.
          </p>
          <div className="profile-identity-row">
            <span>@{profile.username}</span>
            {profile.collegeName && <span>{profile.collegeName}</span>}
          </div>
        </div>
      </div>

      <div className="profile-grid">
        <div className="form-group profileform full-width">
          <label>About</label>
          <div className="profile-static-copy">
            {profile.about || 'No bio has been added yet.'}
          </div>
        </div>

        <div className="form-group profileform">
          <label>LinkedIn</label>
          <div className="profile-static-copy">
            {profile.linkedIn ? (
              <a href={profile.linkedIn} target="_blank" rel="noopener noreferrer">
                {profile.linkedIn}
              </a>
            ) : (
              'Not shared'
            )}
          </div>
        </div>

        <div className="form-group profileform">
          <label>GitHub</label>
          <div className="profile-static-copy">
            {profile.gitHub ? (
              <a href={profile.gitHub} target="_blank" rel="noopener noreferrer">
                {profile.gitHub}
              </a>
            ) : (
              'Not shared'
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
